package com.appsyde.shared.modules.ai.domain.model

import com.appsyde.contract.security.SemanticAnonymizer
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonPrimitive

val json: Json = Json { ignoreUnknownKeys = true }

fun normKey(raw: String?): String =
    raw?.trim()?.lowercase().orEmpty()

/**
 * Parse a JSON string that can be:
 * - A JSON array of strings: ["a","b"]
 * - A JSON string containing an array (double-encoded): "[\\\"a\\\",\\\"b\\\"]"
 * - Invalid/empty -> returns emptySet() (no throw)
 */
fun parseKeysJsonToSet(rawJson: String?): Set<String> {
    val s = rawJson?.trim().takeIf { !it.isNullOrBlank() } ?: return emptySet()
    return runCatching {
        val el = json.parseToJsonElement(s)
        when (el) {
            is JsonArray -> el.mapNotNull { (it as? JsonPrimitive)?.content?.trim() }
                .filter { it.isNotBlank() && !SemanticAnonymizer.looksLikeAnonymizerToken(it) }
                .map { it.lowercase() }
                .toSet()
            is JsonPrimitive -> el.content.trim().takeIf { it.isNotBlank() }?.let { inner ->
                // Double-encoded: the value is itself a JSON array string
                parseKeysJsonToSet(inner)
            } ?: emptySet()
            else -> emptySet()
        }
    }.getOrElse {
        // Fallback: strict list decode (e.g. standard ["a","b"])
        runCatching {
            json.decodeFromString<List<String>>(s)
                .map { it.trim() }
                .filter { it.isNotBlank() && !SemanticAnonymizer.looksLikeAnonymizerToken(it) }
                .map { it.lowercase() }
                .toSet()
        }.getOrNull().orEmpty()
    }
}
